import locales from './locales';

export type LanguageTypes = 'en' | 'ar' | 'ru';
export type ProjectTypes = keyof typeof locales;

export const LANGUAGE_OPTIONS: {value: LanguageTypes; label: string}[] = [
  {value: 'en', label: 'English'},
  {value: 'ar', label: 'Arabic'},
  {value: 'ru', label: 'Russian'},
];

export function getDir(lang: LanguageTypes) {
  if (lang === 'ar') {
    return 'rtl';
  } else {
    return 'ltr';
  }
}

interface Locales {
  en: Record<string, any>;
  ar: Record<string, any>;
  ru: Record<string, any>;
}

export function getCustomLocaleContent(lang: LanguageTypes, customLocales: Locales) {
  const currentLocale = customLocales;
  switch (lang) {
    case 'en':
      return currentLocale.en;
    case 'ar':
      return currentLocale.ar;
    case 'ru':
      return currentLocale.ru;
    default:
      return currentLocale.en;
  }
}

export function getLocaleContent(
  project: ProjectTypes,
  lang: LanguageTypes
): Record<string, string> {
  const projectLocale = locales[project];
  switch (lang) {
    case 'en':
      return projectLocale.en;
    case 'ar':
      return projectLocale.ar;
    case 'ru':
      return projectLocale.ru;
    default:
      return projectLocale.en;
  }
}